module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_açaí.af60f625.png";